import { http, HttpResponse } from 'msw';
import { mockTruktTmsApiUrl } from '../mocks';
import { OrderGetFinancesResponse } from '../services/OrderFinanceService';

export const handlers = [
  http.put(mockTruktTmsApiUrl('/orders/:orderGuid/finances'), () => {
    return HttpResponse.json();
  }),
  http.get(mockTruktTmsApiUrl('/orders/:orderGuid/finances'), () => {
    return HttpResponse.json<OrderGetFinancesResponse>({
      totals: {
        revenue: '200.00',
        expense: '45.00',
        income: '155.00',
        accessorialPay: '0.00',
        accessorialCost: '0.00',
        basePay: '200.00',
        baseCost: '45.00',
        customerPay: '200.00',
        vendorCost: '45.00',
      },
      breakdowns: [
        {
          guid: '9f62b062-03b0-4add-b96c-47150f775a7e',
          invoice: 'INVOICE',
          type: 'CONSIGNEE',
          total: '200.00',
          expense: '0.00',
          income: '200.00',
          accessorials: '0.00',
          basePay: '200.00',
        },
      ],
      commodities: [
        {
          guid: '8046f77f-647c-4a7f-ac85-3da2d7773d56',
          vendorPay: '45.00',
          customerPay: '200.00',
        },
      ],
    });
  }),
];
